<template>
  <div class="prb-section-container">
    <BuilderHeader
      :active="active"
      :finishedSection="finishedSection"
      :index="index"
      :incomplete="incomplete"
      header="Offer Summary"
      section="offer-summary"
      :changeActiveStepIdx="changeActiveStepIdx"
      :toggleInfoModal="showInfo"
    />
    <div
      :class="['pbs-body-container offer-summary', active ? 'active' : null]"
    >
      <div class="pbs-body">Customize your promotion below.</div>
      <div class="pbs-input-container">
        <label class="pbs-input-label" for="title"> Name: </label>
        <span class="pbs-input-sublabel">
          Choose a short name for the promotion that highlights its primary
          benefit.
        </span>
        <input id="title" v-model="title" class="pbs-input" maxlength="80" />
        <div
          :class="['pbs-text-counter', title.length > 80 ? 'error-text' : null]"
        >
          {{ title.length }}/80 characters
        </div>
      </div>
      <div class="pbs-input-container">
        <label class="pbs-input-label" for="sub-title">
          Offer Description:
        </label>
        <span class="pbs-input-sublabel"> Describe the offer’s benefits. </span>
        <textarea id="sub-title" v-model="subTitle" class="pbs-textarea" />
        <div
          :class="[
            'pbs-text-counter',
            subTitle.length > 90 ? 'error-text' : null,
          ]"
        >
          {{ subTitle.length }}/90 characters
        </div>
      </div>
      <div class="pbs-button-container">
        <button
          type="button"
          class="pbs-grey-button"
          :disabled="title.trim().length === 0 || subTitle.length > 90"
          @click="handleContinue"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import promoMixin from '@shared/mixins/promoMixin';
import BuilderHeader from './BuilderHeader.vue';

export default {
  name: 'OfferSummary',
  components: {
    BuilderHeader,
  },
  mixins: [promoMixin],
  props: {
    index: Number,
    active: Boolean,
    promo: Object,
    changeActiveStepIdx: Function,
    finishedSection: Array,
    updatePromo: Function,
    toggleInfoModal: Function,
    setSectionIncomplete: Function,
  },
  data() {
    return {
      title: '',
      subTitle: '',
    };
  },
  computed: {
    incomplete() {
      const { title, subTitle } = this.promo;
      return title != this.title || subTitle !== this.subTitle;
    },
  },
  watch: {
    promo(pr) {
      if (!this.incomplete || this.finishedSection.includes('offer-summary')) {
        this.title = pr.title;
        this.subTitle = pr.subTitle;
      }
    },
    title(t) {
      if (t !== this.promo?.title) {
        this.setSectionIncomplete('offer-summary');
      }
    },
    subTitle(desc) {
      if (desc !== this.promo?.subTitle) {
        this.setSectionIncomplete('offer-summary');
      }
    },
  },
  methods: {
    handleContinue() {
      this.changeActiveStepIdx(this.index + 1);
      const newPromo = {
        ...this.promo,
        promoName: this.title,
        title: this.title,
        cardTitle: this.title,
        subTitle: this.subTitle,
      };
      this.updatePromo(newPromo, 'offer-summary');
    },
    showInfo() {
      this.toggleInfoModal(true, 'offer-summary');
    },
  },
};
</script>
<style lang="scss">
.prb-section-container {
  margin-bottom: 20px;
  .pbs-header-container {
    padding: 10px;
    border-radius: 4px;
    border: 1px solid $N5;
    display: flex;
    align-items: center;
    &.active {
      border-bottom: none;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    .pbs-button {
      background-color: #dbe2f8;
      padding: 2px 18px;
      font-size: 0.625em;
      font-weight: 500;
      color: $N90;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      margin-right: 8px;
    }
    .pbs-done-button {
      background-color: #e3fcef;
      padding: 2px 18px;
      font-size: 0.625em;
      font-weight: 500;
      color: $N90;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      margin-right: 8px;
    }
    .pbs-close-button {
      width: 19px;
      height: 19px;
      background-color: $N5;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
    }
    .pbs-header {
      font-size: 1em;
      font-weight: 500;
      color: $N90;
    }
    .pbs-header-right-container {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .pbs-info-button {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: $E4;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 90%;
        }
      }
      .pbs-check-container {
        background-color: #4cd87d;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        @media (min-width: 1700px) {
          width: 20px;
          height: 20px;
        }
        img {
          width: 50%;
        }
      }
    }
  }
  .pbs-body-container {
    &.date {
      overflow: inherit;
      display: none;
    }
    transition: all 250ms ease-out;
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    position: relative;
    padding: 0 36px;
    &.active {
      opacity: 1;
      display: inherit;
      border: 1px solid $N5;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      padding: 10px 36px 26px;
      &.offer-summary {
        max-height: 325px;
      }
      &.promo-image-section {
        max-height: 800px;
      }
      &.offer-type {
        max-height: 100%;
      }
      &.promo-more-info {
        max-height: 400px;
      }
    }
    .pbs-sub-body-container {
      transition: all ease 250ms;
      &.show {
        opacity: 1;
        height: auto;
      }
      &.hide {
        opacity: 0;
        height: 0;
      }
    }
    .pbs-body {
      font-size: 0.875em;
      color: $N90;
      margin-bottom: 14px;
      font-weight: 500;
    }
    .pbs-subbody {
      font-size: 0.775em;
      color: $N70;
      margin-bottom: 14px;
      font-weight: 400;
    }
    .pbs-title-container {
      display: flex;
      align-items: center;
      .pbs-title {
        font-size: 0.875em;
        color: $NBLUE110;
        font-weight: 500;
        margin-right: 4px;
      }
      .pbs-tooltip-container {
        position: relative;
        display: flex;
        align-items: center;
        .pbs-help-button {
          &:hover {
            & + .pbs-tooltip {
              opacity: 1;
            }
          }
        }
        .pbs-tooltip {
          opacity: 0;
          position: absolute;
          bottom: -25px;
          left: 19px;
          width: 350px;
          font-size: 0.75em;
          color: $N80;
          background-color: #e3fcef;
          padding: 4px 10px;
          transition: opacity 250ms ease-in;
        }
      }
      .pbs-help-button {
        width: 17px;
        height: 17px;
        background-color: $N90;
        color: $WHITE;
        font-size: 0.6em;
        border-radius: 50%;
        font-weight: 700;
        padding-top: 1px;
      }
    }
    .pbs-input-container {
      display: flex;
      flex-direction: column;
      &:not(:last-child) {
        margin-bottom: 8px;
      }
      .pbs-input-label {
        display: flex;
        align-items: center;
        font-size: 0.75em;
        color: $N90;
        font-weight: 500;
        &.med {
          font-weight: 600;
        }
        img {
          margin-right: 2px;
        }
      }
      .pbs-input-sublabel {
        display: flex;
        align-items: center;
        font-size: 0.6em;
        color: $N60;
        font-weight: 400;
      }
      .pbs-input {
        border: 1px solid $N10;
        border-radius: 4px;
        width: 100%;
        height: 28px;
        padding-left: 4px;
        font-size: 0.75em;
        &.width-20 {
          width: 20%;
        }
      }
      .pbs-textarea {
        width: 100%;
        border: 0.5px solid $N10;
        border-radius: 6px;
        height: 60px;
        resize: none;
        padding: 4px 10px;
        font-size: 0.75em;
      }
      .pbs-input-suffix {
        font-size: 0.75em;
        color: $N60;
        margin-left: 4px;
      }
    }
    .pbs-button-container {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 14px;
    }
    .pbs-grey-button {
      font-size: 0.625em;
      color: $N90;
      background-color: #dbe2f8;
      border-radius: 2px;
      padding: 6px 12px;
      line-height: 1;
      &[disabled] {
        background-color: $N40;
        color: $WHITE;
      }
    }
    .pbs-text-counter {
      text-align: right;
      font-size: 0.6875em;
      color: $N60;
      &.error-text {
        color: $TOMATO100;
        font-weight: 700;
      }
    }
    .pbs-error-text {
      font-size: 0.65em;
      color: $TOMATO100;
      font-weight: 500;
      margin-top: 8px;
    }
    .pbs-file-container {
      padding: 10px;
      border-radius: 4px;
      border: 1px solid $N5;
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .pbsf-edit-btn {
        background-color: #e3fcef;
        padding: 2px 18px;
        font-size: 0.625em;
        font-weight: 500;
        color: $N90;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        margin-right: 8px;
      }
      .pbs-file-text {
        font-size: 0.875em;
        color: $N90;
        font-weight: 500;
      }
      .pbs-check-container {
        margin-left: auto;
        background-color: #4cd87d;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        @media (min-width: 1700px) {
          width: 20px;
          height: 20px;
        }
        img {
          width: 50%;
        }
      }
      .pbs-warn-container {
        width: 15px;
        height: 15px;
        img {
          width: 100%;
        }
      }
    }
    .ac-image-upload-form {
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;
      width: 100%;
      height: 80px;
      border: 3px solid $N90;
      border-radius: 12px;
      &:hover {
        opacity: 0.7;
      }
      #file-input {
        cursor: pointer;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
      }
    }
  }
}
</style>
